export default "__VITE_ASSET__DzlcioK0__"